import React, { useEffect, useRef, useState } from 'react'
import {
  Button,
  ButtonToolbar,
  Form,
  Image,
  InputGroup,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap'
import moment from 'moment'
import detailImg from '../../../images/Detail.svg'
import qrCode from '../../../images/qr-code-scan-primary.svg'
import ModalCustom from '../../modal-custom'
import * as htmlToImage from 'html-to-image'
import { Link } from 'react-router-dom'
import {
  createShortUrlsLinkAPI,
  getShortUrlsLinkAPI
} from '../../../services/Qlnk'
import Error_500 from '../../error/error-500'
import { FaCheckCircle } from 'react-icons/fa'
import { FaCircle, FaRegCopy } from 'react-icons/fa6'
import Error_false from '../../error/error-false'
function ShowHistory({
  urlNext,
  fnCleckDetail,
  totalLimits,
  page,
  d,
  i,
  newMenu
}) {
  const [modelQr, setModelQr] = useState(false)
  const [dataModal, setDataModal] = useState([])
  const qrCodeRef = useRef(null)
  const [dataQR, setDateQR] = useState([])
  const [isSave, setIsSave] = useState(false)

  useEffect(() => {
    if (qrCodeRef.current) {
      const qrCode = qrCodeRef.current
      const canvas = qrCode.querySelector('canvas')
      if (canvas) {
        canvas.toDataURL('image/png')
      }
    }
  }, [])

  useEffect(() => {
    if (modelQr) {
      getShortUrlsLink()
    }
  }, [modelQr])

  const handleClose = () => {
    setModelQr(false)
  }

  const handleQR = (d) => {
    setDataModal(d)
    setModelQr(true)

    if (dataModal[0]?.shortUrl && modelQr) {
      getShortUrlsLink()
    } else if (!dataModal[0]?.shortUrl && modelQr) {
      getShortUrlsLink()
    }
  }
  const getShortUrlsLink = async () => {
    try {
      setIsSave(true)
      const searchTerm = `https://staff.skyict.co.th/card2/${dataModal.uuid}`
      const res = await getShortUrlsLinkAPI({ searchTerm })
      setIsSave(false)

      if (!res) return
      setDateQR(res.shortUrls.data)
      if (!res.shortUrls.data[0]?.shortUrl) {
        createShortUrlsLink()
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const handleDownloadQR = () => {
    if (qrCodeRef.current) {
      htmlToImage
        .toPng(qrCodeRef.current)
        .then(function (dataUrl) {
          const link = document.createElement('a')
          link.href = dataUrl
          link.download = 'qr-code.png'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch(function (error) {
          Error_false({ msg: 'Error generating QR code:', error })
        })
    } else {
      Error_false({ msg: 'QR code reference not found' })
    }
  }

  const createShortUrlsLink = async () => {
    const longUrl = `https://staff.skyict.co.th/card2/${dataModal.uuid}`
    const data = await createShortUrlsLinkAPI({ longUrl })
    if (!data) return
    getShortUrlsLink()
  }

  const [isCopy, setIsCopy] = useState(false)
  const renderTooltip = (props) =>
    isCopy ? (
      <Tooltip {...props}>Copied!</Tooltip>
    ) : (
      <Tooltip {...props}>Copy</Tooltip>
    )

  return (
    <>
      <tr className="mb-3 font-small-2 align-middle" key={i}>
        <td>
          {' '}
          <span className="font-small-2">
            {page * totalLimits - totalLimits + i + 1}
          </span>
        </td>
        <td lg={1} className="text-center ">
          <div className="d-flex justify-content-center">
            {d?.is_img ? (
              <FaCheckCircle
                style={{
                  color: '#e8f0fc',
                  fontSize: '30px',
                  backgroundColor: '#1a2b45',
                  borderRadius: '20px'
                }}
              />
            ) : (
              <FaCircle
                style={{
                  color: '#e8f0fc',
                  fontSize: '30px'
                }}
              />
            )}
          </div>
        </td>
        {/* <Image
            fluid
            className="rounded-circle "
            style={{ maxWidth: 40, maxHeight: 40, objectFit: 'cover' }}
            //src={`${URL_PROFILE}/${d?.folder_img}/${d?.code}_cr.jpg`}
            src={`${d?.img_url}`}
            onError={(event) => {
              event.target.src = imgUser
              event.onerror = null
            }}
          /> */}

        <td className="my-auto pe-0">
          <p className="mb-1 font-small-2">{d?.code ?? '-'}</p>
          <p style={{ fontSize: 12 }} className="mb-1 fw-light opacity-50">
            {d?.person_id && `(${d?.person_id})`}
          </p>
        </td>
        <td lg={1} className="my-auto">
          <p className="mb-1  font-small-2">
            {d?.start_date ? moment(d?.start_date).format('DD/MM/YYYY') : '-'}
          </p>
        </td>
        <td lg={2} className="my-auto ">
          {!d?.title_th && !d?.name_th && !d?.surname_th ? (
            <p className="mb-0  font-small-2 ">-</p>
          ) : (
            <p className="mb-0  font-small-2 ">
              <span className="me-1">
                {d?.title_th ?? '-'}
                {d?.name_th ?? '-'}
              </span>{' '}
              <span>{d?.surname_th ?? '-'}</span>
            </p>
          )}
        </td>
        <td lg={1} className="my-auto">
          <p className="mb-1  font-small-2"> {d?.nickname_th ?? '-'}</p>
        </td>
        <td lg={1} className="my-auto text-center">
          <p className="mb-1  font-small-2"> {d?.division ?? '-'}</p>
        </td>
        <td lg={1} className="my-auto text-center">
          <p className="mb-1  font-small-2"> {d?.department ?? '-'}</p>
        </td>
        <td lg={1} className="my-auto ">
          <p className="mb-1  font-small-2"> {d?.team_th ?? '-'}</p>
        </td>
        <td lg={2} className="my-auto">
          <p className="mb-1  font-small-2"> {d?.position_th ?? '-'}</p>
        </td>
        <td lg={2} className="my-auto">
          <p className="mb-1  font-small-2">{d?.type ?? '-'}</p>
        </td>
        <td lg={1} className="my-auto">
          <p className="mb-1  font-small-2">
            <p className="mb-1  font-small-2">{d?.email ? d.email : '-'}</p>
            <p className="mb-0  font-small-2">{d?.phone ? d.phone : '-'}</p>
          </p>
        </td>
        <td className="my-auto text-center">
          <div className="d-flex">
            {newMenu.length > 0 ? (
              <>
                <ButtonToolbar>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-detail">Detail</Tooltip>}
                  >
                    <Button
                      variant="btn btn-outline-primary"
                      className="border-0 gap-2"
                      size="sm"
                      disabled={!urlNext}
                      style={{
                        width: '32px',
                        height: '32px'
                      }}
                      onClick={() => urlNext && fnCleckDetail(d)}
                    >
                      <Image
                        src={detailImg}
                        style={{
                          width: '20px'
                        }}
                      />
                    </Button>
                  </OverlayTrigger>
                </ButtonToolbar>
              </>
            ) : (
              <></>
            )}
            <ButtonToolbar>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-detail">QR Code</Tooltip>}
              >
                <Button
                  variant="btn btn-outline-primary"
                  className="border-0 gap-2"
                  size="sm"
                  style={{
                    width: '32px',
                    height: '32px'
                  }}
                  onClick={() => handleQR(d)}
                >
                  <Image src={qrCode} />
                </Button>
              </OverlayTrigger>
            </ButtonToolbar>
          </div>
        </td>
      </tr>

      {modelQr && (
        <ModalCustom width={600} open={modelQr} onCancel={handleClose}>
          {isSave && <div className="preloader"></div>}

          <div
            className="d-flex justify-content-center m-2 gap-5"
            // ref={qrCodeRef}
          >
            {/* <QRCode
            ref={qrCodeRef}
            className="mt-3"
            size={100}
            style={{ height: 'auto', maxWidth: '50%', width: '50%' }}
            // value={`https://staff.skyict.co.th/card2/${dataModal.uuid}/qr-code`}
            value={`${dataQR[0]?.shortUrl}`}
            viewBox="0 0 256 256"
          /> */}

            <Image
              ref={qrCodeRef}
              className="mt-2"
              style={{ width: '250px' }}
              src={`${dataQR[0]?.shortUrl}/qr-code`}
            />
          </div>

          <div className=" text-center">
            {`${dataModal?.username}-${dataModal?.code}`}
          </div>

          <div className="small text-secondary text-center">
            (สแกนเพื่อรับข้อมูลส่วนบุคคล)
          </div>
          <div className="d-flex justify-content-center mt-3">
            <InputGroup size="sm" className="mb-2 w-50">
              {/* <InputGroup.Text id="inputGroup-sizing-sm">Small</InputGroup.Text> */}
              <Form.Control
                value={dataQR[0]?.shortUrl}
                readOnly
                aria-label="Small"
                aria-describedby="inputGroup-sizing-sm"
              />
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
                onToggle={(e) => {
                  !e && setIsCopy(false)
                }}
              >
                <Button
                  size="sm"
                  // variant="outline-primary"
                  className="px-4"
                  onClick={() => {
                    navigator.clipboard.writeText(dataQR[0]?.shortUrl)
                    setIsCopy(true)
                  }}
                >
                  <FaRegCopy className="me-2 ms-2" />
                </Button>
              </OverlayTrigger>
            </InputGroup>
          </div>

          <Link
            style={{ textDecorationLine: 'none' }}
            target="_blank"
            to={`${dataQR[0]?.shortUrl}`}
          >
            <div className="d-flex justify-content-center">
              <Button
                size="sm"
                variant="outline-primary"
                className=" mt-2 w-50"
                // onClick={handleOpenQR}
              >
                Open
              </Button>
            </div>
          </Link>
          {/* )} */}
          <div className="d-flex justify-content-center">
            <Button
              size="sm"
              className="border-0 mt-2 w-50"
              onClick={handleDownloadQR}
            >
              Download
            </Button>
          </div>
          {/* {dataQR === 0 ? (
          <></>
        ) : (
          <div className="mt-3 overflow-auto">
            <Table bordered>
              <thead>
                <tr>
                  <th className="fw-light small text-center">Link</th>
                  <th className="fw-light small text-center">Download</th>
                </tr>
              </thead>
              <tbody>
                {dataQR.map((d, i) => (
                  <tr key={i}>
                    <td
                      className="fw-light small"
                      style={{ minWidth: '400px' }}
                    >
                      <span className="col-12 row">
                        <span className="col-11">
                          <Link
                            style={{ textDecorationLine: 'none' }}
                            target="_blank"
                            to={d.longUrl}
                          >
                            <input
                              className="border-0 w-100"
                              id="myInput"
                              value={d.shortUrl}
                            >
                            </input>
                          </Link>
                        </span>
                        <span className="col-1">
                          <Button
                            className="pointer-event"
                            variant="outline-secondary"
                            size="sm"
                          >
                            <FaCopy
                              className="color-secondary small"
                              onClick={handleCopyLink}
                            />
                          </Button>
                        </span>
                      </span>
                    </td>
                    <td>
                      <span className="d-flex justify-content-center">
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() => download(d)}
                        >
                          <span className="small">Download</span>
                        </Button>
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )} */}
        </ModalCustom>
      )}
    </>
  )
}

export default ShowHistory
